import { OnlineStep } from '@upstart/harmony/lib/constants';
import { map, filter } from 'lodash';
import { OnlinePseudoSteps } from 'util/constants';
import BackendService from './BackendService';

export default class TrackingService {
  static getOverviewAnalytics(params) {
    return BackendService.get('/tracking/overview', { params });
  }

  static getOnlineAnalytics(params) {
    return BackendService.get('/tracking/onlineAnalytics', { params });
  }

  static getStoreAnalytics(params) {
    return BackendService.get('/tracking/storeAnalytics', { params });
  }

  static async getOnlineDeals(newParams) {
    const params = { ...newParams };
    const initialSteps = params?.steps;
    const steps = [...initialSteps];
    let schedulePickupSelected = false;
    const pickupSelected = initialSteps.indexOf(OnlinePseudoSteps.pickup);
    const deliverySelected = initialSteps.indexOf(OnlinePseudoSteps.delivery);
    if (pickupSelected > -1 && deliverySelected > -1) {
      // Both cannot be selected since a deal cannot have both pickup and delivery
      return { data: [], total: 0 };
    }

    // Change pickup/delivery to schedulePickup
    if (pickupSelected > -1) {
      steps[pickupSelected] = OnlineStep.schedulePickup;
      schedulePickupSelected = true;
    }
    if (deliverySelected > -1) {
      steps[deliverySelected] = OnlineStep.schedulePickup;
      schedulePickupSelected = true;
    }

    params.steps = steps;
    const results = await BackendService.get('/tracking/onlineStatus', {
      params,
      steps,
    });

    // Add pickup/delivery to the results based on Deal.deliveryDetails.address
    let data = map(results?.data, val => {
      const { schedulePickup, Deal } = val;
      if (schedulePickup) {
        return {
          ...val,
          [Deal?.deliveryMethod]: true,
        };
      }
      return val;
    });

    // Filter results if pickup/delivery was selected initially
    if (initialSteps.length > 0 && schedulePickupSelected) {
      data = filter(data, val => {
        if (pickupSelected > -1) {
          return val?.pickup;
        }
        return val?.delivery;
      });
    }
    return { ...results, data };
  }

  static getStoreDeals(params) {
    return BackendService.get('/tracking/storeStatus', { params });
  }

  static getFeatureMetrics(params) {
    return BackendService.get('/tracking/featureMetrics', { params });
  }

  static getVirtualShowroomMetrics(params) {
    return BackendService.get('/tracking/virtualShowroomMetrics', { params });
  }

  static getStoreLendingMetrics(params) {
    return BackendService.get('/tracking/storeLendingMetrics', { params });
  }

  static getOnlineLendingMetrics(params) {
    return BackendService.get('/tracking/onlineLendingMetrics', { params });
  }
}
